import { TYPES } from "../actions";

const initialState = {
  fileUploads: [],
  totalCount: 0,
  currentFileUpload: null,
  stats: null,
  loading: false,
  currentUrl: null
};

export const tkt1FileUploadManagementReducer = (state = initialState, action) => {
  switch (action.type) {

    case TYPES.ACTION_GET_TKT1_FILE_UPLOADS_SUCCESS:
      // Update data and set current URL when data is successfully fetched
      return { 
        ...state, 
        fileUploads: action.payload.data.data, 
        totalCount: action.payload.data.pagination?.total_count > -1 ? action.payload.data.pagination.total_count : state.totalCount,
        currentUrl: action.payload.currentUrl,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_FILE_UPLOADS_FAIL:
      return { 
        ...state, 
        fileUploads: [],
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_FILE_UPLOAD_STATS_SUCCESS:
      return { 
        ...state, 
        stats: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_FILE_UPLOAD_STATS_FAIL:
      return { 
        ...state, 
        stats: null,
        loading: false
      };

    case TYPES.ACTION_SEARCH_TKT1_FILE_UPLOADS_SUCCESS:
      return { 
        ...state, 
        fileUploads: action.payload.data.data, 
        totalCount: action.payload.data.pagination?.total_count > -1 ? action.payload.data.pagination.total_count : state.totalCount,
        loading: false
      };

    case TYPES.ACTION_SEARCH_TKT1_FILE_UPLOADS_FAIL:
      return { 
        ...state, 
        fileUploads: [],
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_FILE_UPLOAD_BY_ID_SUCCESS:
      return { 
        ...state, 
        currentFileUpload: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_FILE_UPLOAD_BY_ID_FAIL:
      return { 
        ...state, 
        currentFileUpload: null,
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_FILE_UPLOAD_SUCCESS:
      return { 
        ...state, 
        fileUploads: state.fileUploads.map(fileUpload => 
          fileUpload._id === action.payload.data._id ? action.payload.data : fileUpload
        ),
        currentFileUpload: state.currentFileUpload && state.currentFileUpload._id === action.payload.data._id 
          ? action.payload.data 
          : state.currentFileUpload,
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_FILE_UPLOAD_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_FILE_UPLOAD_SUCCESS:
      return { 
        ...state, 
        fileUploads: state.fileUploads.filter(fileUpload => fileUpload._id !== action.payload.id),
        totalCount: Math.max(0, state.totalCount - 1),
        currentFileUpload: state.currentFileUpload && state.currentFileUpload._id === action.payload.id 
          ? null 
          : state.currentFileUpload,
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_FILE_UPLOAD_FAIL:
      return { 
        ...state, 
        loading: false
      };
      
    default:
      return state;
  }
};
